import { proforientationApplicationSelectors } from 'portfolio3/features/proforientation/model/selectors';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const proforientationApplicationDodsYearsSelector = createSelector(
  [proforientationApplicationSelectors.dods],
  (proforientationApplicationDods) =>
    extractDatesFromNestedItems(
      [proforientationApplicationDods],
      [
        {
          type: 'date',
          field: 'unformattedEventDate',
        },
      ],
    ),
);
